// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComparablesFilterActions {
  font-size: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-comparables/src/lib/comparables/comparables-filter-actions/comparables-filter-actions.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF","sourcesContent":[".ComparablesFilterActions {\n  font-size: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
